<template>
  <!-- 
    <ith-skeleton 
        width="100px" 
        radius="5px"
        height="20px"
        color="#314c75"
        color2="#425f8a"
        margin="10px"
        />
    -->

  <div :style="style">
    <div class="skeleton">
      <div class="skeleton-loading"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: { type: String, required: true },
    height: { type: String, required: true },
    color: { type: String, required: true },
    color2: { type: String, required: true },
    margin: { type: String, required: false },
    padding: { type: String, required: false },
    radius: { type: String, required: false }
  },
  data() {
    return {
      style: {
        "--color": this.color,
        "--color2": this.color2,
        "--width": this.width,
        "--height": this.height,
        "--margin": this.margin,
        "--padding": this.padding,
        "--radius": this.radius
      }
    };
  }
};
</script>
<style scoped>
.skeleton {
  width: var(--width);
  height: var(--height);
  background: var(--color);
  margin: var(--margin);
  padding: var(--padding);
  border-radius: var(--radius);

  box-shadow: 0 4px 10px 0 rgba(33, 33, 33, 0.15);
  position: relative;
  overflow: hidden;
}
.skeleton-loading::before {
  content: "";
  display: block;
  position: absolute;
  left: var(--width);
  width: var(--width);
  top: 0;
  height: 100%;
  background: linear-gradient(
    to right,
    transparent 0%,
    var(--color2) 50%,
    transparent 100%
  );
  animation: load 1.5s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
@keyframes load {
  from {
    left: calc(var(--width) * -1);
  }
  to {
    left: 100%;
  }
}
/* background-color: #314c75; */
</style>
